module.exports = __webpack_public_path__ + "img/lasting_parenting_icon.ef463314.svg";